import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

interface AgentResponse {
  success: boolean;
  message: string;
  data?: any;
  error?: string;
}

class AgentApiClient {
  private getHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    };
  }

  async sendMessage(message: string, context?: any): Promise<AgentResponse> {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/agent/message`,
        { message, context },
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error sending message to agent:', error);
      throw error;
    }
  }

  async getConversationHistory(): Promise<AgentResponse> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/agent/history`,
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching conversation history:', error);
      throw error;
    }
  }

  async getTasks(): Promise<AgentResponse> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/agent/tasks`,
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching agent tasks:', error);
      throw error;
    }
  }

  async getContext(): Promise<AgentResponse> {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/agent/context`,
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching agent context:', error);
      throw error;
    }
  }
}

export const agentApiClient = new AgentApiClient();
